<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "./assets/style/index.scss";
@import "./assets/style/theme.scss";

#app {
  height: 100%;
}

.main {
  background: $main-bgc;
}
</style>



// WEBPACK FOOTER //
// App.vue?5b172450